import { useEffect, useRef, useState } from 'react';

/**
 * хук для упарвления состоянием сайдбара
 */
export const useSidebar = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isLogoVisible, setIsLogoVisible] = useState(true);

  const enterTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const logoTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  /**
   * Поведение сайдбара при наведении курсора
   */
  const handleMouseEnter = () => {
    if (enterTimeoutRef.current) clearTimeout(enterTimeoutRef.current);
    if (logoTimeoutRef.current) clearTimeout(logoTimeoutRef.current);

    setIsLogoVisible(false);
    enterTimeoutRef.current = setTimeout(() => {
      setIsExpanded(true);
      logoTimeoutRef.current = setTimeout(() => {
        setIsLogoVisible(true);
      }, 200);
    }, 50);
  };

  /**
   * Поведение сайдбара, когда убираем курсор
   */
  const handleMouseLeave = () => {
    if (enterTimeoutRef.current) clearTimeout(enterTimeoutRef.current);
    if (logoTimeoutRef.current) clearTimeout(logoTimeoutRef.current);

    setIsLogoVisible(false);
    setIsExpanded(false);
    logoTimeoutRef.current = setTimeout(() => {
      setIsLogoVisible(true);
    }, 100);
  };

  /**
   * Гасим отложенные таймеры при размонтировании: иначе таймер переживает
   * рельсу и дергает setState у снятого компонента (в тестах это всплывает
   * как «window is not defined» после teardown окружения).
   */
  useEffect(
    () => () => {
      if (enterTimeoutRef.current) clearTimeout(enterTimeoutRef.current);
      if (logoTimeoutRef.current) clearTimeout(logoTimeoutRef.current);
    },
    []
  );

  return {
    isExpanded,
    isLogoVisible,
    handleMouseEnter,
    handleMouseLeave
  };
};
